import { useState, useEffect } from "react"
import { useStore } from "./store"
import Header from "./components/Header"
import Sidebar from "./components/Sidebar"
import SessionsPage from "./pages/SessionsPage"
import ChatPage from "./pages/ChatPage"
import SkillsPage from "./pages/SkillsPage"
import KnowledgePage from "./pages/KnowledgePage"
import StatsPage from "./pages/StatsPage"
import ModelsPage from "./pages/ModelsPage"
import HubPage from "./pages/HubPage"
import CapturesPage from "./pages/CapturesPage"
import ConnecteursPage from "./pages/ConnecteursPage"
import LoginPage from "./pages/LoginPage"
import ProjectsPage from "./pages/ProjectsPage"
import ProjectDetailPage from "./pages/ProjectDetailPage"
import PcIaPage from "./pages/PcIaPage"
import PcFmPage from "./pages/PcFmPage"
import PcArmorPage from "./pages/PcArmorPage"
import PcTufPage from "./pages/PcTufPage"
import PcAgentsPage from "./pages/PcAgentsPage"

type Page = "sessions" | "chat" | "skills" | "knowledge" | "stats" | "hub" | "captures" | "connecteurs" | "projects" | "project-detail" | "pcia" | "pcfm" | "pcarmor" | "pctuf" | "pcagents"

function App() {
  const { setCurrentContext } = useStore()
  const [currentPage, setCurrentPage] = useState<Page>("sessions")
  const [currentProjectName, setCurrentProjectName] = useState<string>("")
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem("claudie_token")
    if (token) {
      setIsAuthenticated(true)
    }
    setLoading(false)
  }, [])

  const handleLoginSuccess = (token: string) => {
    setIsAuthenticated(true)
    setCurrentPage("sessions")
  }

  const handleLogout = () => {
    localStorage.removeItem("claudie_token")
    localStorage.removeItem("claudie_user")
    setIsAuthenticated(false)
    setCurrentPage("chat")
  }

  const handleOpenProject = (projectName: string) => {
    setCurrentProjectName(projectName)
    setCurrentPage("project-detail")
  }

  const handleBackToProjects = () => {
    setCurrentPage("projects")
  }

  const renderPage = () => {
    switch (currentPage) {
      case "sessions":
        return <SessionsPage />
      case "chat":
        return <ChatPage />
      case "skills":
        return <SkillsPage />
      case "knowledge":
        return <KnowledgePage />
      case "stats":
        return <StatsPage onOpenProject={handleOpenProject} />
      case "hub":
        return <HubPage />
      case "captures":
        return <CapturesPage />
      case "connecteurs":
        return <ConnecteursPage />
      case "projects":
        return <ProjectsPage onOpenProject={handleOpenProject} />
      case "pcia":
        return <PcIaPage />
      case "pcfm":
        return <PcFmPage />
      case "pcarmor":
        return <PcArmorPage />
      case "pctuf":
        return <PcTufPage />
      case "pcagents":
        return <PcAgentsPage />
      case "project-detail":
        return <ProjectDetailPage
          projectName={currentProjectName}
          onBack={handleBackToProjects}
        />
      default:
        return <ChatPage />
    }
  }

  if (loading) {
    return (
      <div style={{ backgroundColor: "#111827", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ display: "inline-block", width: "40px", height: "40px", border: "4px solid #374151", borderTop: "4px solid #ec4899", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <LoginPage onLoginSuccess={handleLoginSuccess} />
  }

  return (
    <div style={{ backgroundColor: "#111827", height: "100vh", display: "flex", flexDirection: "column" }}>
      <Header onNavigate={setCurrentPage} currentPage={currentPage} onLogout={handleLogout} />
      <div style={{ flex: 1, overflow: "hidden", display: "flex" }}>
        {currentPage === "chat" && <Sidebar currentPage={currentPage} onNavigate={setCurrentPage} />}

        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          {renderPage()}
        </div>
      </div>
    </div>
  )
}

export default App
